import { useHistory as useReactRouteHistory } from 'react-router-dom'

export const useHistory = useReactRouteHistory

export default useHistory
